import React, { useState } from 'react';
import './ProjectContainer.css';
import ProjectCard from './ProjectCard';

import Project1 from '../assets/Project1.jpg';
import Project2 from '../assets/Project2.png';
import Project3 from '../assets/Project3.png';
import Project4 from '../assets/Project4.png';
import Project5 from '../assets/Project5.png';
import Project6 from '../assets/Project6.png';

const projects = [
  {
    title: 'Robotics Club Website Development',
    image: Project1,
    link: 'http://sanjivani-robotics-website.netlify.app/',
    category: 'Web Development',
    details: `Developed a full-stack web application for the Robotics Club with React, Node.js, Express, and MongoDB. Features include member profiles, events, and contact form.`,
  },
  {
    title: 'Admin Panel',
    image: Project2,
    link: '',
    category: 'Software Development',
    details: `An admin dashboard for managing user roles, data insights, and authentication with React, Express, MongoDB.`,
  },
  {
    title: 'Placement Management System',
    image: Project3,
    link: 'https://pratik9307.github.io/Placement_Management_System/',
    category: 'Web Development',
    details: `A web app for managing placements in colleges — with student registration, company listings, and placement tracking.`,
  },
  {
    title: 'Amazon Clone using ReactJS',
    image: Project4,
    link: 'https://just-clone.netlify.app/',
    category: 'Web Development',
    details: `Built an Amazon-inspired shopping interface with React, fake API integration, cart handling, and responsive design.`,
  },
  {
    title: 'Shopping Cart App',
    image: Project5,
    link: 'https://shoping-cart-app-reactjs.netlify.app/',
    category: 'App Development',
    details: `React-based shopping cart with product listing, add/remove items, and real-time total updates.`,
  },
  {
    title: 'SMART HOME SYSTEM',
    image: Project6,
    link: 'https://smarthome11.netlify.app/',
    category: 'Software Development',
    details: `This project is a company-driven smart home management application designed to provide customers with a seamless way to control, monitor, and customize their smart home devices while enabling the company to gather valuable insights from customer data.
It serves as both a user-facing control system and a backend analytics tool for improving services, enhancing product design, and delivering personalized experiences.`,
  },
];

const categories = [
  'All',
  'Web Development',
  'Software Development',
  'App Development',
  'AI',
  'ML',
  'Robotics',
];

const ProjectContainer = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('All');

  const filteredProjects =
    selectedCategory === 'All'
      ? projects
      : projects.filter((project) => project.category === selectedCategory);

  const openProjectDetails = (project) => {
    setSelectedProject(project);
  };

  const closeProjectDetails = () => {
    setSelectedProject(null);
  };

  return (
    <div className="project-container" id="projects">
      <h1 className="container-title">My Projects</h1>

      {/* Category Filter */}
      <div className="category-filters text-center mb-4">
        {categories.map((category, index) => (
          <button
            key={index}
            className={`filter-button ${
              selectedCategory === category ? 'active' : ''
            }`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Project Cards */}
      <div className="card-grid">
        {filteredProjects.map((project, index) => (
          <ProjectCard
            key={index}
            title={project.title}
            image={project.image}
            link={project.link}
            onCardClick={() => openProjectDetails(project)}
          />
        ))}
      </div>

      {/* Modal */}
      {selectedProject && (
        <div className="project-modal">
          <div className="modal-content">
            <button onClick={closeProjectDetails} className="close-button">
              &times;
            </button>
            <h2>{selectedProject.title}</h2>
            <p>{selectedProject.details}</p>
            {selectedProject.link && (
              <a
                href={selectedProject.link}
                target="_blank"
                rel="noopener noreferrer"
                className="project-modal-link"
              >
                🔗 Visit Project
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectContainer;
